import styled from '@emotion/styled';
import Icons from '@shared/components/core/images/Icons';
import {
    ActionWrapper,
    Content,
    EmptyContent,
    ListingCard,
    Table,
    TableHeading,
} from '@shared/components/core/listing/CommonListingStyles';
import { CardTitleCentered } from '@shared/components/core/text/CardTypography';
import { BodySmall } from '@shared/components/core/text/Typography';
import HotkeyModel from '@shared/models/deviceProfiles/HotkeyModel';
import { useTranslation } from 'react-i18next';

export interface IHotkeysListingProps {
    hotkeys: HotkeyModel[];
    showDescription?: boolean;
}

function HotkeysListing({ hotkeys, showDescription = true }: IHotkeysListingProps) {
    const { t } = useTranslation();
    return (
        <ListingCard>
            {hotkeys.length > 0 ? (
                <>
                    <CardTitleCentered>{t('common:hotkey.titlePlural')}</CardTitleCentered>
                    {showDescription && <BodySmall>{t('common:hotkey.description')}</BodySmall>}

                    <Table>
                        <thead>
                            <ActionWrapper>
                                <Content as="th">
                                    <TableHeading>{t('common:hotkey.when')}</TableHeading>
                                </Content>
                                <Content as="th">
                                    <TableHeading>{t('common:thenMacro')}</TableHeading>
                                </Content>
                            </ActionWrapper>
                        </thead>
                        <tbody>
                            {hotkeys.map((hotkey, i) => {
                                return (
                                    <ActionWrapper key={`hotkey_${i}`}>
                                        <Content>
                                            <Icons
                                                name="virtualButton"
                                                size={24}
                                                ariaLabel={t('common:hotkey.title')}
                                            />
                                            <p>{hotkey.displayName}</p>
                                        </Content>
                                        <Content>
                                            <MacroTitle>
                                                {hotkey.macroName ? hotkey.macroName : hotkey.command}
                                            </MacroTitle>
                                            <Icons name="logo" size={24} ariaLabel={t('common:steps')} />
                                        </Content>
                                    </ActionWrapper>
                                );
                            })}
                        </tbody>
                    </Table>
                </>
            ) : (
                <EmptyContent>{t('common:hotkey.emptySearch')}</EmptyContent>
            )}
        </ListingCard>
    );
}

const MacroTitle = styled.p`
    text-transform: capitalize;
`;

export default HotkeysListing;
